/* Mod City Madness picture menu: places the picture tiles into the phone menu and the computer Shop / Makers panels */
(function(){
  if(window.__mpm)return;window.__mpm=1;
  function frag(id){var t=document.getElementById(id);return t?t.content.cloneNode(true):null;}
  function txt(el){return (el&&el.textContent||'').replace(/\s+/g,' ').trim();}
  function init(){
    /* homepage quick links: Fix reads as Restore */
    document.querySelectorAll('.mobile-quick-links__item').forEach(function(a){if(txt(a).toLowerCase()==='fix')a.textContent='Restore';});
    /* phone menu */
    var nav=document.querySelector('#menu-drawer .menu-drawer__navigation');
    var d=frag('mpm-drawer');
    if(nav&&d&&!nav.classList.contains('mpm-on')){
      nav.insertBefore(d,nav.firstChild);
      nav.classList.add('mpm-on');
      nav.querySelectorAll(':scope > .menu-drawer__menu > li').forEach(function(li){
        var s=li.querySelector(':scope > details > summary');
        var t=txt(s);
        if(t==='Shop'||t==='Designers & Brands')li.style.display='none';
      });
      var p=document.createElement('p');p.className='mpm-textus';
      p.innerHTML='Questions? Text <a href="sms:+19736521150">973-652-1150</a>';
      var ul=nav.querySelector(':scope > .menu-drawer__menu');if(ul)ul.appendChild(p);
    }
    /* computer panels */
    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(function(det){
      var span=det.querySelector('summary span'),t=txt(span),box=det.querySelector('.mega-menu__content');
      if(!box)return;
      if(t==='Shop'){var m=frag('mpm-mega');if(m){box.innerHTML='';box.appendChild(m);}}
      else if(t==='Designers & Brands'){var k=frag('mpm-makers');if(k){span.textContent='Makers';box.innerHTML='';box.appendChild(k);}}
    });
    /* text us, computer header */
    var icons=document.querySelector('.header__icons');
    if(icons&&!icons.querySelector('.mcm-textus-top')){
      var a=document.createElement('a');a.className='mcm-textus-top small-hide medium-hide';a.href='sms:+19736521150';a.textContent='Text 973-652-1150';
      icons.insertBefore(a,icons.firstChild);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
